import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

const SITE = "https://www.newspaceuk.com";

// Accessible breadcrumb trail + BreadcrumbList JSON-LD for local SEO.
export default function Breadcrumbs({ items, variant = "dark" }) {
  useEffect(() => {
    const id = "breadcrumb-jsonld";
    const data = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.label,
        item: `${SITE}${it.to || ""}`,
      })),
    };
    let s = document.getElementById(id);
    if (!s) {
      s = document.createElement("script");
      s.id = id;
      s.type = "application/ld+json";
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(data);
    return () => { const el = document.getElementById(id); if (el) el.remove(); };
  }, [items]);

  const light = variant === "light";
  const base = light ? "text-white/70" : "text-[#7a716a]";
  const linkHover = light ? "hover:text-white" : "hover:text-[#ec008c]";
  const current = light ? "text-white" : "text-[#16323f]";
  const sep = light ? "text-white/40" : "text-[#c9a25e]";

  return (
    <nav aria-label="Breadcrumb" data-testid="breadcrumbs">
      <ol className={`flex flex-wrap items-center gap-1.5 text-xs font-medium ${base}`}>
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.label} className="flex items-center gap-1.5">
              {last || !it.to ? (
                <span className={last ? current : ""} aria-current={last ? "page" : undefined}>
                  {it.label}
                </span>
              ) : (
                <Link
                  to={it.to}
                  className={`${linkHover} transition-colors`}
                  data-testid={`breadcrumb-link-${i}`}
                >
                  {it.label}
                </Link>
              )}
              {!last && <ChevronRight size={13} className={sep} />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
